export default "__VITE_ASSET__PoRRwZr1__"